<template>
  <v-container>
    <toolbar mode="report" :title="report ? report.name : 'Edit'" view="list" />
    <v-progress-linear v-if="loading" indeterminate />
    <report-form 
      v-else
      :report="report"
      :working="working"
      @submit="onSubmit"
      @cancel="$router.push({ name: 'reportList' })"
    />
  </v-container>
</template>

<script>
import toolbar from "@/components/toolbar"
import ReportForm from "@/components/Reports/ReportForm"
import Reports from "@/api/reports"

export default {
  name: "ReportEdit",
  components: {
    toolbar,
    ReportForm
  },
  data() {
    return {
      report: null,
      loading: false,
      working: false
    }
  },
  mounted() {
    this.fetchReport()
  },
  methods: {
    fetchReport() {
      const uuid = this.$route.params.uuid
      this.loading = true
      this.setBusy(true)
      
      Reports.retrieve(uuid)
        .then(response => {
          this.report = response.data
        })
        .catch(_ => {
          this.notify('Failed to load report', 'red')
          this.$router.push({ name: 'reportList' })
        })
        .finally(() => {
          this.loading = false
          this.setBusy(false)
        })
    },
    onSubmit(reportData) {
      this.working = true

      const payload = {
        prediction: reportData.prediction,
        config: reportData.config
      }

      Reports.patch(this.report.uuid, payload)
        .then(response => {
          this.notify('Updating Report...')
          this.$router.push({ name: 'reportList' })
        })
        .catch(_ => {
          const errorMsg = 'Failed to update report'
          this.notify(errorMsg, 'red')
        })
        .finally(() => {
          this.working = false
        })
    }
  }
}
</script>
